import React from "react";
import Countdown from "react-countdown";
import { Col, Container, Input, InputGroup, Row } from "reactstrap";
import ParticlesAuth from "../../AuthenticationInner/ParticlesAuth";
import comingsoon from "../../../assets/images/comingsoon.png";

const ComingSoon = () => {
  const renderer = ({ days, hours, minutes, seconds, completed }: any) => {
    if (completed) {
      return <span>Você está pronto para ir!</span>;
    } else {
      return (
        <>
          <div className="countdownlist">
            <div className="countdownlist-item">
              <div className="count-title">Dias</div>
              <div className="count-num">{days}</div>
            </div>
            <div className="countdownlist-item">
              <div className="count-title">Horas</div>
              <div className="count-num">{hours}</div>
            </div>
            <div className="countdownlist-item">
              <div className="count-title">Minutos</div>
              <div className="count-num">{minutes}</div>
            </div>
            <div className="countdownlist-item">
              <div className="count-title">Segundos</div>
              <div className="count-num">{seconds}</div>
            </div>
          </div>
        </>
      );
    }
  };

  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="auth-page-content">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center mt-sm-5 pt-4 mb-4">
                  <div className="mb-sm-5 pb-sm-4 pb-5">
                    <img
                      src={comingsoon}
                      alt=""
                      height="120"
                      className="move-animation"
                    />
                  </div>
                  <div className="mb-5">
                    <h1 className="display-2 coming-soon-text">Em breve</h1>
                  </div>
                  <div>
                    <Row className="justify-content-center mt-5">
                      <Col lg={8}>
                        <Countdown date="2024/12/31" renderer={renderer} />
                      </Col>
                    </Row>
                    <div className="mt-5">
                      <h3>Seja notificado quando lançarmos</h3>
                      <p className="text-muted">
                        Não se preocupe, não enviaremos spam para você 😊
                      </p>
                    </div>
                    <InputGroup className="countdown-input-group mx-auto my-4">
                      <Input
                        type="email"
                        className="form-control border-light shadow"
                        placeholder="Enter your email address"
                      />
                      <button className="btn btn-success" type="button">
                        Enviar
                        <i className="ri-send-plane-2-fill align-bottom ms-2"></i>
                      </button>
                    </InputGroup>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default ComingSoon;
